//Peticiones HTTP para temas referentes a Login y datos de usuario
import axios from 'axios';
import { AppUrls, } from './Globals';
import { Config } from './Config';

export const notificationRequests = {}//Objeto agrupador de funciones


notificationRequests.ReSendNip = (data) => {//Función de autenticación
  return axios.post(
    AppUrls.ResendNip,//url
    Config.SetParameters(data, '', '', ''),//Objeto a enviar al API
    Config.ConfigAuth(sessionStorage.getItem('token'))//headers
  ).then(handleResponse)//next => actions => AuthActions
}

notificationRequests.SendNip = (data) => {//Función de autenticación
  return axios.post(
    AppUrls.validatePIN,//url
    Config.SetParameters(data, '', '', ''),//Objeto a enviar al API
    Config.ConfigAuth(sessionStorage.getItem('token'))//headers
  ).then(handleResponse)//next => actions => AuthActions
}

notificationRequests.UpdateMetadata = (data) => {//Función de autenticación
  return axios.post(
    AppUrls.UpdateMetadata,//url
    Config.SetParameters(data, '', '', ''),//Objeto a enviar al API
    Config.ConfigAuth(sessionStorage.getItem('token'))//headers
  ).then(handleResponse)//next => actions => AuthActions
}

notificationRequests.GetQrImage = (data) => {
  console.log('se esta haciendo la petición', data)
  return axios.get(
    AppUrls.GetQrImage + "?text=" + data,
    Config.ConfigNoAuth()
  ).then(handleDocument)
}

notificationRequests.NotificationPINChangePassword = (data) => {
  return axios.post(
    AppUrls.NotificationPINChangePassword,
    Config.SetParameters(data, '', '', ''),
    Config.ConfigNoAuth()
  ).then(handleResponse)
}

//desencripta y devuelve objeto de la respuesta del API
let handleResponse = (response) => {
  let respObject = response.data;//BodySecurityResponse(response.data);
  if (!respObject.IsOK) {
    let responseObject = { message: respObject.Messages + ' ' + (respObject.TansactionId ? respObject.TansactionId : '') + ' ' + (respObject.statusText ? respObject.statusText : '') };
    const error = (respObject.Body || responseObject);
    return Promise.reject(error);
  }
  return respObject;
}

function getType(type) {
  switch (type) {
    case '.png':
      return 'image/png'
    case '.jpg':
      return 'image/jpeg'
  }
}

let handleDocument = (response) => {
  console.log("response****: ", response)
  const headerval = response?.headers['content-disposition'];
  console.log("headerval****: ", headerval)
  let extFile = '';

  
  extFile = headerval != undefined? '.' + headerval.split('.')[1].substring(0, 3): ".png";

  //Create a Blob from the Stream
  const file = new Blob(
    [response.data],
    //{ type: response.data.type }
    { type: getType(extFile) }
  );//Build a URL from the file
  const fileURL = URL.createObjectURL(file);//Open the URL on new Window

  let respObject = {
    data: fileURL,
    url: response.config.url,
    type: getType(extFile),
    extension: extFile
  };

  if (response.status != 200 &&
    response.statusText != "OK") {
    let responseObject = { message: response.Messages + ' ' + (response.TansactionId ? response.TansactionId : "") + ' ' + (response.statusText ? response.statusText : "") };
    const error = (respObject.Body || responseObject);
    return Promise.reject(error);
  } else {
    return respObject;
  }
}

/*let handleResponse = (response) => {
  let respObject = response.data;//BodySecurityResponse(response.data);
  if (!respObject.IsOK) {
    let responseObject = { message: respObject.Messages + ' ' + (respObject.TansactionId ? respObject.TansactionId : '') + ' ' + (respObject.statusText ? respObject.statusText : '') };
    let error = (respObject.Body || responseObject);
    return Promise.reject(error);
  }
  return respObject;
}*/
